import React, { FC } from 'react'

import type { ButtonProps } from '../../Button'
import { Button } from '../../Button'
import { SetStepCursor, StepCursor } from '../../FullScreenStepper/FullScreenStepperProps'
import { augmentButtonProps } from './augmentButtonProps'

export const StepperActionsCancelButton: FC<{
  setStepCursor: SetStepCursor
  stepCursor: StepCursor
  cancelButtonText?: string
  cancelButtonProps?: ButtonProps
  handleCancelClick?: () => Promise<void>
  displayCancelButton: boolean
}> = (props) => {
  const { setStepCursor, stepCursor, cancelButtonText, cancelButtonProps, handleCancelClick, displayCancelButton } =
    props
  const augmentedCancelButtonProps = augmentButtonProps(
    { onClick: handleCancelClick },
    cancelButtonProps,
    setStepCursor,
    stepCursor,
    0,
  )

  return displayCancelButton ? (
    <Button variant="ghost" {...augmentedCancelButtonProps}>
      {cancelButtonText || 'cancel'}
    </Button>
  ) : null
}
